import { Helmet } from "react-helmet";
import React, { Component } from "react";
import "../../styles/depots/depots.scss";
import { Button } from "react-bootstrap";
import DepotTable from "./depotTable";
import axios from "axios";
import { encodeQueryData, apiHost } from "../../api/apiClient";
import { Link } from "react-router-dom";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import queryString from "query-string";
import { connect } from "react-redux";

class Depots extends Component {

  constructor(props) {
    super(props);
    this.state = {
      depotList: [],
    };
  }

  async componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    console.log("customerID", values.customerId);
    var urlAll = "";
    if (values.customerId) {
      this.customerId = values.customerId;
      let query = encodeQueryData(this.setCustomersQueryObject());
      urlAll = `${apiHost}/api/Depots/GetAllDepots?${query}`;
    } else {
      urlAll = `${apiHost}/api/Depots/GetAllDepots`;
    }

    this.props.setLoadingPageAction(true);
    try {
      const response = await axios.get(urlAll, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      response.data.sort((a, b) => {
        if (a.customerName.toLowerCase() < b.customerName.toLowerCase()) {
          return -1;
        } else if (a.customerName.toLowerCase() > b.customerName.toLowerCase()) {
          return 1;
        } else if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        } else if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        } else {
          return 0;
        }
      })
      this.setState({ depotList: response.data });
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  }

  setCustomersQueryObject = () => {
    let data = {};
    data.SearchString = this.searchText;
    data.customerId = this.customerId;
    data.PageSize = this.pageSize;
    data.PageNumber = this.pageKey;
    data.SortDirection = this.sortDirection;
    data.SortString = this.sortString;
    return data;
  };

  render() {
    const { depotList } = this.state;
    const values = queryString.parse(this.props.location.search);

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>All depots </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h2>
                All Depots
                {values.customerId && (
                  <small>
                    {`filtered by customerName `}
                    <a
                      onClick={() => localStorage.removeItem("customer")}
                      href="/depots"
                    >
                      <span>
                        <i className=" fa fa-times"></i>
                        {values.customerName}
                      </span>
                    </a>
                  </small>
                )}
              </h2>
              <div className="buttonContainer">
                <Link to="/createDepot">
                  <Button variant="primary">Create new</Button>
                </Link>
              </div>

              <div className="customers">
                <DepotTable depots={depotList} />
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Depots);
